import fvSubassembly from "../fvSubassembly";
export default class fvRect extends fvSubassembly {
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
        this.createSucss();
        this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
    }
    init(){
        super.init();
        if(this.originalSize.width/(this.frameScaleX+1) >= 2){
          this.width -= 1;
        }
        this.moveWidth = this.borderWidth/2;
    }
    onDraw(canvas){
        this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
        if(this.height == 0 || this.width == 0) return
        this.formatRect();
        this.executePreAnimation(canvas);
        // 
        canvas.beginPath();
        canvas.canvas["type"]='Rect';
        canvas.save();
        //矩形填充使用
        this.regionHeight = this.height -  this.borderWidth;
        this.regionWidth = this.width -  this.borderWidth;
        if(this.lineType >= 1){
            canvas.setLineDash(this.lineStyle(this.lineType));
        }
        if(this.color=="" || this.opacity<=0){
            canvas.fillStyle = "rgba(255, 255, 255, 0)";//矩形填充透明
        }else{
            var rgbArray = this.color.colorRgb(this.opacity/255);;
            canvas.fillStyle = rgbArray;//矩形填充颜色
        }
        if(this.borderWidth == 0){
            canvas.strokeStyle = rgbArray;
        }else{
            canvas.strokeStyle = this.borderColor;//边框颜色
        }
        //设置线宽度
        if(this.borderWidth == 0){
            canvas.lineWidth = 0.01;
        }else{
            canvas.lineWidth = this.borderWidth;
        }
        var lin = canvas.lineWidth/2;
        if(this.renderType > 0){
            //线宽小于等于3情况下极端情况
            if(this.width <= 3){
                var rgbArray = this.color.colorRgb(this.opacity/255);
                canvas.strokeStyle = rgbArray;//边框颜色
                
                canvas.lineWidth = 1;
            }
            if(this.round){
                this.roundRect(canvas,this.cx+lin,this.cy+lin,this.width,this.height,this.changeGrond(),0); //实心圆角矩形
            }else{
                canvas.rect(this.cx+lin,this.cy+lin,parseFloat(this.width),parseFloat(this.height));
            };
        }else{
            if(this.color){
                //注意：填充颜色长宽为减去边框
                if(this.round){
                   this.roundRect(canvas,this.cx+lin,this.cy+lin,this.width,this.height,this.changeGrond(),1); //实心圆角矩形
                }else{
                    canvas.fillRect(this.cx+lin,this.cy+lin,this.width,this.height);//矩形坐标及大小
                }
            }
            if(this.borderWidth > 0){
                //注意：边框绘制重线条中间开始，长宽为减去一倍的边框
                if(this.round){
                    this.roundRect(canvas,this.cx+lin,this.cy+lin,this.width,this.height,this.changeGrond(),0); //空心圆角矩形
                }else{
                    if(this.lineTypeStyle){
                        if(!this.lineTypeStyle.isStereo){ 
                            canvas.strokeRect(this.cx+lin,this.cy+lin,this.width,this.height);//矩形边框
                        }
                    }else{
                        canvas.strokeRect(this.cx+lin,this.cy+lin,this.width,this.height);//矩形边框
                    }
                }
            }
            
            if(this.opacity > 0){
                var rgbArray = this.color.colorRgb(this.opacity/255);
                this.color = rgbArray ;
            }else{
                var rgbArray1 = this.color.colorRgb(0.0001);
                this.color = rgbArray1;
            }
        }
        
        this.Render(canvas);
        this.executePosAnimation(canvas);
        canvas.stroke();
        if(this.lineTypeStyle){
            if(this.lineTypeStyle.isStereo){ 
                this.drawStereo(canvas);
            }
        }
        canvas.stroke();

        canvas.restore();

        
    }
    //绘制管道
    drawStereo(canvas){
        var byR0,byG0,byB0;
        var nR1,nG1,nB1;
        var Color = [];
        var rgbArr = [];
        rgbArr = this.borderColor.colorRgb();
        if(rgbArr.length != 3){
            byR0 = 0;
            byG0 = 0;
            byB0 = 255;
        }else{
            byR0 = rgbArr[0];
            byG0 = rgbArr[1];
            byB0 = rgbArr[2];
        }
        Color = this.lineTypeStyle.stereoColor.colorRgb();
        nR1 = Color[0];
        nG1 = Color[1];
        nB1 = Color[2];
        var fAddR,fAddG,fAddB;
        var w = Math.max(1,parseInt(this.borderWidth));
        fAddR = (nR1-byR0)/w;
        fAddG = (nG1-byG0)/w;
        fAddB = (nB1-byB0)/w;

        var faddx,faddy;
        var parm = {};
        parm.faddx = faddx;
        parm.faddy = faddy;
        parm.faddx = 0;	parm.faddy = 0.0;

        faddx = parm.faddx;
        faddy = parm.faddy;

        var nPenStyle;

        var nCount;
        var pPotPtr = [];

        var tempParm = {};
        tempParm.nCount = nCount;
        tempParm.pPotPtr = pPotPtr;

        this.GetPtr(tempParm);

        nCount = tempParm.nCount;
        pPotPtr = tempParm.pPotPtr;

        var nBakCount = tempParm.nCount;
        var pPotBak = new Array(nBakCount);
        var i=0;
        for(; i<nBakCount; i++)//备份点的信息
        {
            pPotBak[i] = {};
            pPotBak[i].x = pPotPtr[i].x;
            pPotBak[i].y = pPotPtr[i].y;
        }

        var bUsePath = 1;
        var fWidthAdd;
        if(parseInt(this.borderWidth) <= 8)
            fWidthAdd = 2.0;
        else
            fWidthAdd = 2.0 * parseInt(this.borderWidth)/32.0 + 2.0;

        i = -999;
        for(var fj =1.0; fj<=parseInt(this.borderWidth); fj+=fWidthAdd){
            // if((i == Math.ceil(fj)) || (i+1 == Math.ceil(fj)))
            //     continue;
            i = Math.ceil(fj);//这三行代码保证只有在线宽差距较大时才画，提高了效率

            var colorStyle = "rgb(";
            var tempr = byR0+fAddR*i>255?255:byR0+fAddR*i;
            var tempg = byG0+fAddG*i>255?255:byG0+fAddG*i;
            var tempb = byB0+fAddB*i>255?255:byB0+fAddB*i;
            colorStyle += Math.ceil(tempr) + "," + Math.ceil(tempg) + "," + Math.ceil(tempb) + ")";
            canvas.strokeStyle = colorStyle;
            canvas.lineWidth = parseInt(this.borderWidth) + 1 - i;
            for(var j=0; j<nCount; j++)
            {
                pPotPtr[j].x = pPotBak[j].x + /*ddddcount*10 +*/ Math.ceil(faddx*i);
                pPotPtr[j].y = pPotBak[j].y +  Math.ceil(faddy*i);
            }
            canvas.beginPath();
            canvas.moveTo(pPotPtr[0].x,pPotPtr[0].y);
            //是否圆角
            if(this.round){
                for(var i = 1 ;i < pPotPtr.length; i++) {
                    canvas.arcTo(pPotPtr[i].x,pPotPtr[i].y,pPotPtr[i].w,pPotPtr[i].h,pPotPtr[i].r);
                }
            }else{
                for(var i = 1 ;i < pPotPtr.length; i++) {
                    canvas.lineTo(pPotPtr[i].x,pPotPtr[i].y);
                }
            }
            canvas.closePath()
            canvas.stroke();
        }
    }
    //计算绘制边框点
    GetPtr(parm){
        if(this.round){
            parm.nCount = 5;
            parm.pPotPtr = new Array(parm.nCount);//备份点信息
            var r = this.changeGrond();
            var x = this.cx;
            var y = this.cy;
            var w = this.width;
            var h =  this.height;
            if(parseFloat(r)<0){
                r = 0.1;
            }
            parm.pPotPtr = [
                {
                    x:parseFloat(x)+parseFloat(r),
                    y:parseFloat(y)
                },
                {
                    x:parseFloat(x)+parseFloat(w),
                    y:parseFloat(y),
                    w:parseFloat(x)+parseFloat(w),
                    h:parseFloat(y)+parseFloat(h),
                    r:parseFloat(r)
                },
                {
                    x:parseFloat(x)+parseFloat(w),
                    y:parseFloat(y)+parseFloat(h),
                    w:parseFloat(x),
                    h:parseFloat(y)+parseFloat(h),
                    r:parseFloat(r) 
                },
                {
                    x:parseFloat(x),
                    y:parseFloat(y)+parseFloat(h),
                    w:parseFloat(x),
                    h:parseFloat(y),
                    r:parseFloat(r) 
                },
                {
                    x:parseFloat(x),
                    y:parseFloat(y),
                    w:parseFloat(x)+parseFloat(w),
                    h:parseFloat(y),
                    r:parseFloat(r) 
                }
            ]
        }else{
            parm.nCount = 4;
            parm.pPotPtr = new Array(parm.nCount);//备份点信息
            parm.pPotPtr = [
                {
                    x:this.cx,
                    y:this.cy
                },
                {
                    x:this.cx+this.width,
                    y:this.cy
                },
                {
                    x:this.cx+this.width,
                    y:this.cy+this.height  
                },
                {
                    x:this.cx,
                    y:this.cy+this.height 
                }
            ]
        }
    }
    Render(canvas) {
        var SIN_COS_API=3.141592625;
        var rd = this.renderConfig;
        var m_fRotate = SIN_COS_API/180 * parseFloat(0); //跟draw的精度一样
        if(rd.color){
            var colorNum = rd.color.length;
        }
        var rect = {
            left : this.cx,
            top : this.cy,
            bottom : parseFloat(this.cy + this.regionHeight),
            right :parseFloat(this.cx + this.regionWidth),
            width : parseFloat(this.width),
            height : parseFloat(this.height)
        }
        if(this.render){
            // this.render.rend(canvas,rect,this);
            switch (this.renderType){
                case 1:  //模式1
                    this.render.rend(canvas,rect,rd.grade,"",rd.color,colorNum,rd.colorGrade,m_fRotate);
                    break;
                case 2:  //模式2
                    this.render.rend(canvas,rect,rd.grade,"",rd.color,colorNum,rd.colorGrade,m_fRotate,rd.rendShape,rd.centerPos,rd.rotate);
                    break;
                case 3:  //模式3
                    this.render.rend(canvas,this,this.color,rd.grade);
                    break;
                case 4:  //canvas线性渐变效果
                case 5:  //canvas路径渐变效果
                case 6:  //canvas纹理渐变效果
                    this.render.rend(canvas,rect,this);
                default:
                    break;
            }
        }
    }
    roundRect(canvas,x, y, w, h, r,flag) {
        //圆半径不能为负数
        if(parseFloat(r)<0){
            r = 0.1;
        }
        canvas.beginPath();
        if(this.round[0]>this.round[1]){
            //纵向
            if(this.round[0]-this.round[1]>15){
                r = this.changeGrond1();
                h = parseFloat(h)-r;
                y = parseFloat(y)+r/2;
                canvas.moveTo(parseFloat(x), parseFloat(y));
                canvas.bezierCurveTo(parseFloat(x),parseFloat(y)-r, parseFloat(x)+parseFloat(w), parseFloat(y)-r,parseFloat(x)+parseFloat(w),parseFloat(y));
                canvas.lineTo(parseFloat(x)+parseFloat(w),parseFloat(y)+parseFloat(h));
                canvas.bezierCurveTo(parseFloat(x)+parseFloat(w),parseFloat(y)+parseFloat(h)+r, parseFloat(x), parseFloat(y)+parseFloat(h)+r,parseFloat(x),parseFloat(y)+parseFloat(h));
                canvas.closePath();
            }else{
                canvas.moveTo(parseFloat(x)+parseFloat(r), parseFloat(y));
                canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(r));//右上
                canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(r));//右下
                canvas.arcTo(parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y), parseFloat(r));//左上
                canvas.arcTo(parseFloat(x), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(r));//左下
                canvas.closePath();
            }
        }else{
            //横向
            if(this.round[1]-this.round[0]>15){
                r = this.changeGrond1();
                w = parseFloat(w)-r;
                x = parseFloat(x)+r/2;
                canvas.moveTo(parseFloat(x), parseFloat(y));
                canvas.bezierCurveTo(parseFloat(x)-r,parseFloat(y),parseFloat(x)-r,parseFloat(y)+parseFloat(h),parseFloat(x),parseFloat(y)+parseFloat(h));
                canvas.lineTo(parseFloat(x)+parseFloat(w),parseFloat(y)+parseFloat(h));
                canvas.bezierCurveTo(parseFloat(x)+parseFloat(w)+r,parseFloat(y)+parseFloat(h),parseFloat(x)+parseFloat(w)+r,parseFloat(y),parseFloat(x)+parseFloat(w),parseFloat(y));
                canvas.closePath()
            }else{
                canvas.moveTo(parseFloat(x)+parseFloat(r), parseFloat(y));
                canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(r));//右上
                canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(r));//右下
                canvas.arcTo(parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y), parseFloat(r));//左上
                canvas.arcTo(parseFloat(x), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(r));//左下
                canvas.closePath();
            }
        }
        if(flag == 1){
            canvas.fill();
        }else{
            canvas.stroke();
        }
        canvas.stroke();
    }
    //判断如果圆角最大值不能超过宽高的一半
    changeGrond(){
        if(this.round[0]*2 > this.width || this.round[0]*2 > this.height){
            var widthHeight = this.width > this.height?this.height:this.width;
            this.round[0] = widthHeight/2;
        }
        return this.round[0];
    }
    changeGrond1(){
        if(this.round[1]*2 > this.width || this.round[1]*2 > this.height){
            var widthHeight = this.width > this.height?this.height:this.width;
            this.round[1] = widthHeight/2;
        }
        return this.round[1];
    }
    /*16进制颜色转为RGBA格式*/
    hexToRgba(hex, opacity) {
        return "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + opacity + ")";
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvRectObj.js